import { render, staticRenderFns } from "./locale-selector.vue?vue&type=template&id=f6f76624&"
import script from "./locale-selector.vue?vue&type=script&lang=ts&"
export * from "./locale-selector.vue?vue&type=script&lang=ts&"
import style0 from "./locale-selector.vue?vue&type=style&index=0&id=f6f76624&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports